export type StudyExecutionMode = 'argo' | 'local'

export function resolveDefaultStudyExecutionMode(args: {
  dev: boolean
  explicitMode?: string
}): StudyExecutionMode | undefined {
  const explicit =
    typeof args.explicitMode === 'string'
      ? args.explicitMode.trim().toLowerCase()
      : ''
  if (explicit === 'argo') {
    return 'argo'
  }
  // Local execution is a dev-only testing affordance. Production builds must
  // never be forced onto the local simulation path, even if the env var leaks
  // into a build. See apps/frontend/.env.example.
  if (explicit === 'local' && args.dev) {
    return 'local'
  }
  return undefined
}

export function getDefaultStudyExecutionMode(): StudyExecutionMode | undefined {
  return resolveDefaultStudyExecutionMode({
    dev: import.meta.env.DEV,
    explicitMode: import.meta.env.DT_VITE_STUDY_EXECUTION_MODE,
  })
}

export function withDefaultStudyExecutionMode<T extends Record<string, unknown>>(
  payload: T,
): T & { executionMode?: StudyExecutionMode } {
  const executionMode = getDefaultStudyExecutionMode()
  return executionMode ? { ...payload, executionMode } : payload
}
